interface BookmarkDescriptionProps {
  description?: string;
  condensedView: boolean;
}

function BookmarkDescription({ description, condensedView }: BookmarkDescriptionProps) {
  // Don't render anything in condensed view or without description
  if (condensedView || !description) {
    return null;
  }

  return <div className="text-bookmark-description line-clamp-2">{description}</div>;
}

export default BookmarkDescription;
